import { FC } from 'react';
import { Card, Col, Grid, Image, Row, Typography } from 'antd';
import Text from 'antd/lib/typography/Text';

import IconCustom from 'src/components/Icon/Custom';
import { formatDateListArticels } from 'src/utils/func/format-date';

import classes from './article.module.less';

interface CardArticleInterface {
	data?: any;
}

const truncateString = (str: string) => {
	if (str?.length > 30) {
		return `${str.substring(0, 30)}...`;
	}
	return str;
};

const truncateString2 = (str: string) => {
	if (str?.length > 40) {
		return `${str.substring(0, 40)}...`;
	}
	return str;
};

const CardArticleLainnya: FC<CardArticleInterface> = (props) => {
	const { xs } = Grid.useBreakpoint();

	return (
		<div className={classes.containerCard}>
			<Row>
				{props?.data?.map((item: any) => {
					return (
						<Col sm={8} md={8} lg={8} xl={8} xs={24} key={item.id}>
							<a
								href={
									`${
										item.type == 'post-pregnancy'
											? '/pasca-kehamilan/'
											: item.type == 'pre-pregnancy'
											? '/pra-kehamilan/'
											: item.type == 'pregnancy'
											? '/kehamilan/'
											: item.type == 'recipe'
											? '/resep/'
											: '/artikel/'
									}` + item.slug
								}
								id="detail-artikel-kumpulan-artikel-lainnya"
							>
								<span>
									<Card
										size="small"
										hoverable={false}
										className={classes.cards}
										style={{
											cursor: 'pointer',
										}}
										cover={
											<Image
												alt="example"
												src={item.media_images.original}
												className={classes.imageContainer}
												style={{
													width: '367px',
													height: '203px',
													borderRadius: '20px',
													objectFit: 'cover',
												}}
												preview={false}
											/>
										}
									>
										<Typography className={classes.title}>{truncateString(item.title)}</Typography>

										<Row>
											<Col
												className="d-flex align-items-center"
												style={{ marginLeft: xs ? '-5px' : '-15px' }}
											>
												<Text className="fs-12 fs-md-14">
													Diterbitkan pada {formatDateListArticels(item?.publish_date || '')}
												</Text>
											</Col>
										</Row>
										<Row>
											<Col
												className="d-flex align-items-center"
												style={{ marginLeft: xs ? '-5px' : '-15px' }}
											>
												<Text className="fs-12 fs-md-14" style={{ color: '#9ca3aa' }}>
													{truncateString2(item?.short_desc) || ''}
												</Text>
											</Col>
										</Row>
										<Row>
											<Col
												className="d-flex align-items-center"
												style={{ marginLeft: xs ? '-5px' : '-15px' }}
											>
												<IconCustom iconName="heart" />
												<Text className="fs-12 fs-md-14 ml-2" style={{ color: '#9ca3aa' }}>
													{item.total_like}
												</Text>
											</Col>
											<Col className="d-flex align-items-center" style={{ marginLeft: '10px' }}>
												<IconCustom iconName="comment" />
												<Text className="fs-12 fs-md-14 ml-2" style={{ color: '#9ca3aa' }}>
													{item.total_comment}
												</Text>
											</Col>
										</Row>
									</Card>
								</span>
							</a>
						</Col>
					);
				})}
			</Row>
		</div>
	);
};

export default CardArticleLainnya;
